import api from '../../infrastructure/config/api';

export const tradeOrderService = {
  async place(symbol, side) {
    const response = await api.post('/api/trade/order', { symbol, side });
    return response.data?.data;
  },
};
